import { DndContext, closestCenter, PointerSensor, TouchSensor, KeyboardSensor, useSensor, useSensors } from "@dnd-kit/core";
import { SortableContext, useSortable, arrayMove, verticalListSortingStrategy, sortableKeyboardCoordinates } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { GripVertical } from "lucide-react";

function Row({ s, i }) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: s.id });
  return (
    <li ref={setNodeRef} style={{ transform: CSS.Transform.toString(transform), transition }} {...attributes} {...listeners}
      className={`flex touch-none cursor-grab items-center gap-3 rounded-lg border bg-white px-3 py-3 text-sm ${isDragging ? "z-10 shadow-lg ring-2 ring-[color:var(--dcbc-red)]" : ""}`}
      data-testid={`section-order-row-${i}`}>
      <GripVertical className="h-4 w-4 shrink-0 text-muted-foreground" />
      <span className="w-6 text-muted-foreground">{i + 1}.</span>
      <span className="font-semibold">{s.title || "Untitled section"}</span>
      <span className="ml-auto text-xs text-muted-foreground">{s.lessons.length} lesson{s.lessons.length === 1 ? "" : "s"}</span>
    </li>
  );
}

export function SectionOrder({ sections, onChange }) {
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 5 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 150, tolerance: 5 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates }),
  );
  const end = ({ active, over }) => {
    if (!over || active.id === over.id) return;
    const from = sections.findIndex((s) => s.id === active.id);
    const to = sections.findIndex((s) => s.id === over.id);
    onChange(arrayMove(sections, from, to));
  };
  return (
    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={end}>
      <SortableContext items={sections.map((s) => s.id)} strategy={verticalListSortingStrategy}>
        <ul className="space-y-2" data-testid="section-order-list">{sections.map((s, i) => <Row key={s.id} s={s} i={i} />)}</ul>
      </SortableContext>
    </DndContext>
  );
}
